import { apiMapaMina } from "./utils/api";

export const getPriceSearch = async (idCliente) => {
  if (!navigator.onLine) {
    return null;
  }
  const response = await apiMapaMina.get(`/api/MapaMina/${idCliente}`);
  return response.data;
};

export const deletePriceSearch = async () => {
  return null;
};

export const updatePriceSearch = async () => {
  return null;
};

export const savePriceSearch = async () => {
  return null;
};

export const salvarAtualizacoesPesquisas = async () => {
  return null;
};

export const setFecharConsomeBasicoCliente = async () => {
  return null;
};
